import { z } from 'zod';
import { esquemaId, esquemaMotivo } from './comunes.js';
/**
 * Sucursales, equipos, credenciales y acceso entre medicos (F5.5, ADM-03,
 * plan maestro §3.1 y §3.4, supuesto S-02).
 *
 * - Politica de acceso a pacientes, por consultorio:
 *   - `todos`: el equipo comparte a todos los pacientes (lo de siempre; los
 *     consultorios existentes la conservan).
 *   - `equipo-tratante`: un medico ve solo a los pacientes con los que tiene
 *     un vinculo asistencial (alta, asignacion o remision interna), propio o de
 *     un equipo suyo. El propietario, como director clinico, ve a todos.
 * - La remision interna agrega un vinculo con fecha, motivo y responsable. No
 *   hay busqueda de pacientes entre consultorios.
 * - Una credencial lleva evidencia y la REVISA una persona responsable: no hay
 *   «validacion automatica».
 */
export const POLITICAS_DE_ACCESO = ['todos', 'equipo-tratante'];
export const esquemaCambiarPoliticaDeAcceso = z
    .object({ politica: z.enum(POLITICAS_DE_ACCESO), motivo: esquemaMotivo })
    .strict();
export const esquemaSucursal = z
    .object({
    nombre: z.string().trim().min(2).max(120),
    direccion: z.string().trim().max(300).default(''),
})
    .strict();
export const esquemaEquipo = z
    .object({
    nombre: z.string().trim().min(2).max(120),
    sucursalId: esquemaId.nullable().default(null),
    miembros: z.array(esquemaId).max(100).default([]),
})
    .strict();
export const ORIGENES_DE_VINCULO = ['alta', 'asignacion', 'remision'];
/** Asignar o remitir: a una persona o a un equipo, nunca a los dos. */
export const esquemaVinculoAsistencial = z
    .object({
    usuarioId: esquemaId.optional(),
    equipoId: esquemaId.optional(),
    origen: z.enum(['asignacion', 'remision']),
    motivo: esquemaMotivo,
    hasta: z.coerce.date().optional(),
})
    .strict()
    .refine((v) => (v.usuarioId === undefined) !== (v.equipoId === undefined), {
    message: 'Indique una persona o un equipo',
    path: ['usuarioId'],
});
export const esquemaFinDeVinculo = z.object({ motivo: esquemaMotivo }).strict();
export const TIPOS_DE_CREDENCIAL = [
    'cedula-profesional',
    'cedula-especialidad',
    'certificacion',
    'otra',
];
export const ESTADOS_DE_CREDENCIAL = ['declarada', 'revisada', 'rechazada'];
export const esquemaCredencial = z
    .object({
    tipo: z.enum(TIPOS_DE_CREDENCIAL),
    numero: z.string().trim().min(3).max(40),
    institucion: z.string().trim().min(2).max(200),
    /** Que respalda la credencial: dónde consultarla, el documento que se vio. */
    evidencia: z.string().trim().min(5).max(500),
    vigenteHasta: z.coerce.date().optional(),
})
    .strict();
export const esquemaRevisionDeCredencial = z
    .object({ estado: z.enum(['revisada', 'rechazada']), motivo: esquemaMotivo })
    .strict();
//# sourceMappingURL=equipos.js.map